import React from "react";

import { ConfirmModal } from "components/shared/ConfirmModal";

export function DeleteConfirmModal(props) {
  const { show, appId, appName, onConfirm, onClose } = props;
  function executeAndClose() {
    onConfirm(appId, appName);
    onClose();
  }

  return (
    <React.Fragment>
      {show && (
        <ConfirmModal
          onConfirm={executeAndClose}
          onClose={onClose}
          title={`Confirm deletion of ${props.appName}.`}
          bodyText={props.children}
        />
      )}
    </React.Fragment>
  );
}
